import script from "./AddMultipleMember.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMultipleMember.vue?vue&type=script&setup=true&lang=js"

import "./AddMultipleMember.vue?vue&type=style&index=0&id=e3ee22d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3ee22d8"]])

export default __exports__